module.exports = __webpack_public_path__ + "static/img/wisdomvalue.1856d56f.png";